// extracted by mini-css-extract-plugin
export var black = "mobile-nav-panel-module--black--d2e6e";
export var closeBtn = "mobile-nav-panel-module--close-btn--7854e";
export var closeIcon = "mobile-nav-panel-module--close-icon--f0743";
export var container = "mobile-nav-panel-module--container--f247f";
export var header = "mobile-nav-panel-module--header--843e6";
export var logoBox = "mobile-nav-panel-module--logo-box--a9e2a";
export var logoWatermark = "mobile-nav-panel-module--logo-watermark--c6e11";
export var navPanel = "mobile-nav-panel-module--nav-panel--08b53";
export var opened = "mobile-nav-panel-module--opened--46ce7";